import { Input, Directive } from '@angular/core';

@Directive()
export class InputBaseComponent {
  @Input() name: string;
  @Input() id: string;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() col = 12;
  @Input() value: any;
  @Input() class: string;
  @Input() disabled = false;
  @Input() hide = false;
  @Input() errore = '';
}
